const L = '@charset "UTF-8";:host{display:block;font-family:var(--schema-font-family, ui-sans-serif, system-ui, -apple-system);color:var(--schema-color-fg, #111827)}*,*:before,*:after{box-sizing:border-box}.wrapper{display:block;background:var(--schema-color-bg, #ffffff)}.form{display:grid;gap:12px}.field{display:grid;gap:6px;padding:8px 10px;border:1px solid var(--schema-color-muted, #e5e7eb);border-radius:var(--schema-radius, 10px);background:var(--schema-surface, #fff)}.label{font-size:12px;color:var(--schema-color-muted-text, #6b7280)}.input,select,textarea{width:100%;padding:8px 10px;border-radius:8px;border:1px solid var(--schema-color-muted, #e5e7eb);background:var(--schema-input-bg, #fff);color:inherit}.checkbox{display:inline-flex;align-items:center;gap:8px}.helper{font-size:12px;color:var(--schema-color-muted-text, #6b7280)}.row{display:grid;gap:8px}.actions{display:flex;gap:8px}.btn{padding:6px 10px;border:1px solid var(--schema-color-muted, #e5e7eb);background:var(--schema-btn-bg, #f8fafc);border-radius:8px;cursor:pointer;color:var(--schema-color-fg)}.btn.primary{background:var(--schema-color-primary, #2563eb);color:#fff;border-color:transparent}.btn:disabled{opacity:.5;cursor:not-allowed}.btn.danger{background:var(--schema-color-danger, #dc2626);color:#fff;border-color:transparent}.group{display:grid;gap:10px}.kv{display:grid;grid-template-columns:1fr 1fr auto;gap:8px;align-items:center}.badge{display:inline-flex;padding:2px 6px;border-radius:999px;font-size:11px;background:var(--schema-badge-bg, #eef2ff);color:var(--schema-badge-fg, #4f46e5)}.hidden{display:none!important}.toolbar{display:flex;gap:6px}.schema-collection-row{position:relative;transition:transform var(--schema-collection-transition-duration, .25s) var(--schema-collection-transition-ease, ease),opacity var(--schema-collection-transition-duration, .25s) var(--schema-collection-transition-ease, ease)}.schema-collection-row.enter{opacity:0}.schema-collection-row.enter.enter-active{opacity:1}.schema-collection-row.leaving{opacity:0}.field.schema-type-array .group,.field.schema-type-array .group .row{position:relative}.keyshortcut-wrap{display:flex;gap:.5em;align-items:center}.keyshortcut-btn{padding:6px 8px;font-size:1em}.keyshortcut-btn.recording{background:var(--schema-color-primary, #2563eb);color:#fff;border-color:transparent;animation:keyshortcut-pulse .5s ease-in-out infinite}@keyframes keyshortcut-pulse{0%,to{opacity:1}50%{opacity:.6}}', K = {
  arrayAdd: "+",
  arrayMoveUp: "↑",
  arrayMoveDown: "↓",
  arrayRemove: "×",
  dictAdd: "+",
  dictRemove: "×",
  rootLabel: "root"
}, y = (o, n) => {
  customElements.get(o) || customElements.define(o, n);
}, ae = (o, n, s) => {
  if (!n.length) return;
  let e = o, t = null, i = null;
  for (let r = 0; r < n.length - 1; r++) {
    const c = n[r];
    let l = e?.[c];
    l == null ? (l = typeof n[r + 1] == "number" ? [] : {}, e[c] = l) : typeof l != "object" && (l = typeof n[r + 1] == "number" ? [] : {}, e[c] = l), t = e, i = c, e = l;
  }
  const a = n[n.length - 1];
  if (e == null || typeof e != "object") {
    const r = typeof a == "number" ? [] : {};
    if (t)
      t[i] = r, e = r;
    else
      return;
  }
  try {
    e[a] = s;
  } catch {
    try {
      const c = Array.isArray(e) ? e.slice() : { ...e };
      c[a] = s, t && (t[i] = c);
    } catch {
    }
  }
}, M = (o) => o.map(String).join("."), re = (o) => o.replace(/[^a-zA-Z0-9_-]/g, "_"), F = (o) => `schema_${re(M(o) || "root")}`, T = (o) => M(o), u = (o, ...n) => {
  const s = new Set(n);
  s.size && o.setAttribute("part", Array.from(s).join(" "));
}, oe = [
  "wrapper",
  "form",
  "field",
  "field-intersect",
  "field-string",
  "field-number",
  "field-boolean",
  "field-date",
  "field-const",
  "field-array",
  "field-object",
  "field-tuple",
  "field-union",
  "field-dict",
  "field-label",
  "field-helper",
  "field-group",
  "field-row",
  "field-actions",
  "field-button",
  "field-button-primary",
  "field-button-danger",
  "field-button-secondary",
  "field-toolbar",
  "field-badge",
  "field-input",
  "field-input-text",
  "field-input-number",
  "field-input-date",
  "field-input-select",
  "field-input-textarea",
  "field-input-checkbox",
  "field-const-value",
  "collection-row",
  "field-checkbox",
  "field-checkbox-text",
  "field-toolbar-select"
].join(" ");
function O(o, n) {
  if (n == null) return n;
  switch (o) {
    case "number":
    case "natural":
    case "percent": {
      if (n === "") return;
      const s = Number(n);
      return Number.isNaN(s) ? void 0 : s;
    }
    case "boolean":
      return !!n;
    case "date": {
      if (!n) return;
      const s = new Date(n);
      return Number.isNaN(+s) ? void 0 : s;
    }
    default:
      return n;
  }
}
function z(o) {
  return typeof o == "function" && !!o?.type;
}
function V(o) {
  if (!o) throw new Error("schema is required");
  if (z(o)) return o;
  try {
    const n = Schema.from(o);
    if (z(n)) return n;
  } catch {
  }
  if (o?.type) {
    const n = o.type;
    if (Schema[n]) return Schema[n](o.inner ?? o.list ?? o.dict);
  }
  throw new Error("无法从传入对象生成 Schemastery 实例，请传入 schema 或 schema.toJSON() 的结果。");
}
function w(o) {
  return o?.meta ?? {};
}
function ce(o) {
  return o.length > 0 && o.every((n) => n?.type === "const");
}
function P(o) {
  if (!o) return;
  const n = o, s = n.meta || {};
  if (Object.prototype.hasOwnProperty.call(s, "default")) return s.default;
  const e = n.type;
  try {
    const t = o();
    if (t !== void 0) return t;
  } catch {
  }
  switch (e) {
    case "string":
      return "";
    case "number":
    case "natural":
    case "percent":
      return 0;
    case "boolean":
      return !1;
    case "array":
      return [];
    case "tuple":
      return [];
    case "object":
      return {};
    case "dict":
      return {};
    case "union": {
      const t = n.list || [];
      return t.length ? P(t[0]) : void 0;
    }
    case "const":
      return n.value;
    case "date":
      return;
    case "intersect": {
      const t = n.list || [], i = (r, c) => {
        if (Array.isArray(r) && Array.isArray(c)) return c.slice();
        if (r && c && typeof r == "object" && typeof c == "object") {
          const l = { ...r };
          for (const h of Object.keys(c))
            l[h] = h in l ? i(l[h], c[h]) : c[h];
          return l;
        }
        return c ?? r;
      };
      let a = {};
      for (const r of t) a = i(a, P(r));
      return a;
    }
    default:
      return;
  }
}
class k extends HTMLElement {
  constructor() {
    super(), this._path = [], this._i18n = K, this.$root = this.attachShadow({ mode: "open" });
    const n = document.createElement("style");
    n.textContent = L, this.$root.appendChild(n);
  }
  /** 初始化公共容器（带类名与 data-path） */
  makeFieldContainer(n, s) {
    const e = document.createElement("div");
    if (e.className = `field schema-form-item schema-type-${n}`, e.setAttribute("data-path", M(this._path)), u(e, "field", `field-${n}`), this._label) {
      const t = document.createElement("label");
      t.className = "label", t.textContent = this._label, u(t, "field-label"), e.appendChild(t);
    }
    if (s && s !== this._label) {
      const t = document.createElement("div");
      t.className = "helper", t.textContent = s, u(t, "field-helper"), e.appendChild(t);
    }
    return e;
  }
  /** 外部设置 schema/path/label/value */
  set schema(n) {
    this._schema = V(n), this.render();
  }
  get schema() {
    return this._schema;
  }
  set path(n) {
    this._path = n ?? [], this.render();
  }
  get path() {
    return this._path;
  }
  set label(n) {
    this._label = n, this.render();
  }
  get label() {
    return this._label;
  }
  set i18n(n) {
    n && (this._i18n = { ...this._i18n, ...n }), this.render();
  }
  get i18n() {
    return this._i18n;
  }
  setValue(n) {
    this._value = n, this.render();
  }
  getValue() {
    return this._value;
  }
  /** 触发变更事件（冒泡） */
  emitChange(n) {
    this._value = n, this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: !0,
        composed: !0,
        detail: { path: this._path, value: n }
      })
    );
  }
}
class I extends k {
  static {
    this.recEnd = null;
  }
  render() {
    if (this.$input && this.$root.contains(this.$input)) {
      const i = !!this.$root.querySelector("label.label");
      if (!(!!this._label && !i)) {
        const r = this._value ?? "";
        this.$input.value !== r && document.activeElement !== this.$input && (this.$input.value = r);
        return;
      }
    }
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this.makeFieldContainer("string", n.description), e = document.createElement("input");
    this.$input = e, e.className = "input", u(e, "field-input", "field-input-text"), e.type = "text", e.name = T(this._path), e.id = F(this._path), n?.pattern?.source && (e.pattern = n.pattern.source), n?.max != null && (e.maxLength = n.max), e.value = this._value ?? "", e.oninput = () => this.emitChange(O("string", e.value));
    const t = s.querySelector("label.label");
    if (t && (t.htmlFor = e.id), n.role === "keyshortcut") {
      const i = document.createElement("div");
      i.className = "keyshortcut-wrap";
      const a = document.createElement("button");
      a.type = "button", a.className = "btn keyshortcut-btn", a.title = "Record shortcut", a.textContent = "⌨";
      let r = null;
      const c = () => {
        r && (r(), r = null, a.classList.remove("recording"), a.title = "Record shortcut", I.recEnd === c && (I.recEnd = null));
      };
      a.onclick = () => {
        if (r) {
          c();
          return;
        }
        I.recEnd?.(), I.recEnd = c, a.classList.add("recording"), a.title = "Press your keys! (Esc to cancel)";
        const l = (h) => {
          if (h.preventDefault(), h.stopPropagation(), h.key === "Escape") {
            c();
            return;
          }
          const f = [];
          h.ctrlKey && f.push("ctrl"), h.metaKey && f.push("meta"), h.altKey && f.push("alt"), h.shiftKey && f.push("shift");
          const m = h.key.toLowerCase();
          if (["control", "meta", "alt", "shift"].includes(m)) return;
          f.push(m);
          const d = f.join("-"), p = e.value.trimEnd();
          p.toLowerCase().split(/\s*,\s*/).includes(d) || (e.value = p ? p.replace(/,+$/, "") + ", " + d : d, this.emitChange(e.value)), c();
        };
        document.addEventListener("keydown", l, { capture: !0 }), r = () => document.removeEventListener("keydown", l, { capture: !0 });
      }, i.appendChild(e), i.appendChild(a), s.appendChild(i);
    } else
      s.appendChild(e);
    this.$root.appendChild(s);
  }
}
y("schema-form-string", I);
class J extends k {
  render() {
    if (this.$input && this.$root.contains(this.$input)) {
      const a = !!this.$root.querySelector("label.label");
      if (!(!!this._label && !a)) {
        const c = this._value ?? "";
        this.$input.value !== String(c) && document.activeElement !== this.$input && (this.$input.value = c);
        return;
      }
    }
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = this._schema?.type ?? "number", s = w(this._schema), e = this.makeFieldContainer("number", s.description), t = document.createElement("input");
    this.$input = t, t.className = "input", u(t, "field-input", "field-input-number"), t.name = T(this._path), t.id = F(this._path), s?.min != null && (t.min = String(s.min)), s?.max != null && (t.max = String(s.max)), s?.step != null && (t.step = String(s.step)), n === "percent" && !t.step && (t.step = "0.01"), t.value = this._value ?? "", t.oninput = () => this.emitChange(O(n, t.value));
    const i = e.querySelector("label.label");
    i && (i.htmlFor = t.id), s.role === "slider" ? t.type = "range" : t.type = "number", e.appendChild(t), this.$root.appendChild(e);
  }
}
y("schema-form-number", J);
class Y extends k {
  render() {
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this.makeFieldContainer("boolean", n.description), e = document.createElement("label");
    e.className = "checkbox", u(e, "field-checkbox");
    const t = document.createElement("input");
    t.type = "checkbox", t.checked = !!this._value, t.name = T(this._path), t.id = F(this._path), u(t, "field-input", "field-input-checkbox");
    const i = document.createElement("span");
    i.textContent = n.description ?? this._label ?? "", u(i, "field-checkbox-text"), t.onchange = () => this.emitChange(t.checked);
    const a = s.querySelector("label.label");
    a && (a.htmlFor = t.id), e.append(t, i), s.appendChild(e), this.$root.appendChild(s);
  }
}
y("schema-form-boolean", Y);
function q(o) {
  return String(o).padStart(2, "0");
}
function D(o) {
  return `${o.getFullYear()}-${q(o.getMonth() + 1)}-${q(o.getDate())}`;
}
function R(o) {
  return `${q(o.getHours())}:${q(o.getMinutes())}`;
}
function j(o) {
  return `${D(o)}T${R(o)}`;
}
class X extends k {
  render() {
    if (this.$input && this.$root.contains(this.$input)) {
      const a = !!this.$root.querySelector("label.label");
      if (!(!!this._label && !a)) {
        const l = w(this._schema).role || "date";
        if (document.activeElement !== this.$input)
          if (this._value instanceof Date)
            l === "date" ? this.$input.value = D(this._value) : l === "time" ? this.$input.value = R(this._value) : l === "datetime" && (this.$input.value = j(this._value));
          else if (typeof this._value == "string" && l !== "time") {
            const h = new Date(this._value);
            isNaN(+h) || (l === "date" ? this.$input.value = D(h) : l === "datetime" && (this.$input.value = j(h)));
          } else this._value || (this.$input.value = "");
        return;
      }
    }
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this.makeFieldContainer("date", n.description), e = document.createElement("input");
    this.$input = e, e.className = "input", u(e, "field-input", "field-input-date");
    const t = n.role || "date";
    if (t === "datetime" ? e.type = "datetime-local" : t === "time" ? e.type = "time" : e.type = "date", e.name = T(this._path), e.id = F(this._path), this._value instanceof Date)
      t === "date" ? e.value = D(this._value) : t === "time" ? e.value = R(this._value) : t === "datetime" && (e.value = j(this._value));
    else if (typeof this._value == "string" && t !== "time") {
      const a = new Date(this._value);
      isNaN(+a) || (t === "date" ? e.value = D(a) : t === "datetime" && (e.value = j(a)));
    }
    e.oninput = () => {
      n.role;
      let a;
      if (!e.value)
        a = void 0;
      else {
        const r = new Date(e.value);
        a = Number.isNaN(+r) ? void 0 : r;
      }
      this.emitChange(a);
    };
    const i = s.querySelector("label.label");
    i && (i.htmlFor = e.id), s.appendChild(e), this.$root.appendChild(s);
  }
}
y("schema-form-date", X);
class B extends k {
  render() {
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this._schema.value;
    if (n.role === "raw-html") {
      if (s instanceof Node) {
        this.$root.append(s);
        return;
      } else if (typeof s == "function") {
        this.$root.append(s());
        return;
      } else if (typeof s == "string") {
        const a = document.createElement("div");
        a.innerHTML = String(s), u(a, "field-const-value"), this.$root.appendChild(a);
        return;
      }
    }
    const e = this.makeFieldContainer("const", n.description), t = document.createElement("section");
    t.className = "const content", t.textContent = String(s), t.id = F(this._path), u(t, "field-const-value");
    const i = e.querySelector("label.label");
    i && (i.htmlFor = t.id), e.appendChild(t), this.$root.appendChild(e);
  }
}
y("schema-form-const", B);
class Z extends k {
  render() {
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this.makeFieldContainer("intersect", n.description);
    s.classList.remove("field");
    const e = document.createElement("div");
    e.classList.add("group"), u(e, "field-group");
    const t = this._schema.list || [], i = t.length > 0 && t.every((r) => r?.type === "object"), a = (r, c) => {
      if (Array.isArray(r) && Array.isArray(c)) return c.slice();
      if (r && c && typeof r == "object" && typeof c == "object") {
        const l = { ...r };
        for (const h of Object.keys(c))
          l[h] = h in l ? a(l[h], c[h]) : c[h];
        return l;
      }
      return c ?? r;
    };
    if (i) {
      const r = this._value && typeof this._value == "object" ? this._value : {};
      t.forEach((c, l) => {
        const h = c?.meta?.description ?? "", f = A(c, this._path, r, h, this._i18n);
        f.addEventListener("change", (m) => {
          m.stopPropagation();
          const d = a(this._value ?? {}, m.detail.value);
          this.emitChange(d);
        }), e.appendChild(f);
      });
    } else {
      const r = t[t.length - 1], c = A(r, this._path, this._value, this._label, this._i18n);
      c.addEventListener("change", (l) => {
        l.stopPropagation(), this.emitChange(l.detail.value);
      }), e.appendChild(c);
    }
    s.appendChild(e), this.$root.appendChild(s);
  }
}
y("schema-form-intersect", Z);
function le(o) {
  switch (o.type) {
    case "intersect":
      return "schema-form-intersect";
    case "string":
      return "schema-form-string";
    case "number":
    case "natural":
    case "percent":
      return "schema-form-number";
    case "boolean":
      return "schema-form-boolean";
    case "date":
      return "schema-form-date";
    case "const":
      return "schema-form-const";
    case "array":
      return "schema-form-array";
    case "object":
      return "schema-form-object";
    case "tuple":
      return "schema-form-tuple";
    case "dict":
      return "schema-form-dict";
    case "union": {
      const s = o.list || [];
      return s.length === 2 && s[0]?.type === "is" && s[0]?.constructor === Date && s[1]?.type === "transform" && (s[1]?.inner?.meta?.role === "datetime" || s[1]?.inner?.meta?.role === "date" || s[1]?.inner?.meta?.role === "time") ? "schema-form-date" : "schema-form-union";
    }
    default:
      return "schema-form-string";
  }
}
function A(o, n, s, e, t) {
  const i = le(o), a = document.createElement(i);
  return a.schema = o, a.path = n, a.label = e, t && (a.i18n = t), a.setValue?.(s), a.setAttribute("exportparts", oe), a;
}
class G extends k {
  render() {
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this.makeFieldContainer("union", n.description), e = this._schema.list || [];
    if (ce(e)) {
      const t = document.createElement("select");
      t.className = "input", u(t, "field-input", "field-input-select"), t.name = T(this._path), t.id = F(this._path), e.forEach((a) => {
        const r = document.createElement("option");
        r.value = String(a.value), r.textContent = String(a.meta?.description || a.value || a.type), this._value === a.value && (r.selected = !0), t.appendChild(r);
      }), t.onchange = () => this.emitChange(O("string", t.value));
      const i = s.querySelector("label.label");
      i && (i.htmlFor = t.id), s.appendChild(t);
    } else {
      const t = document.createElement("div");
      t.className = "toolbar", u(t, "field-toolbar");
      const i = document.createElement("select");
      i.className = "input", u(i, "field-input", "field-input-select", "field-toolbar-select"), i.name = T(this._path) + ".__type", i.id = F(this._path) + "__type";
      let a = 0;
      e.forEach((h, f) => {
        const m = document.createElement("option");
        m.value = String(f), m.textContent = String(h.meta?.description || h.value || h.type), i.appendChild(m);
      }), i.onchange = () => {
        a = Number(i.value);
        const h = e[a], f = P(h);
        this.emitChange(f), l();
      };
      const r = s.querySelector("label.label");
      r && (r.htmlFor = i.id), t.appendChild(i), s.appendChild(t);
      const c = document.createElement("div");
      c.className = "group", u(c, "field-group");
      const l = () => {
        c.innerHTML = "";
        const h = e[a], f = A(h, this._path, this._value, this._label);
        f instanceof B || (f.addEventListener("change", (m) => {
          m.stopPropagation(), this.emitChange(m.detail.value);
        }), c.appendChild(f));
      };
      l(), s.appendChild(c);
    }
    this.$root.appendChild(s);
  }
}
y("schema-form-union", G);
class Q extends k {
  render() {
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this.makeFieldContainer("tuple", n.description), e = document.createElement("div");
    e.className = "group", u(e, "field-group");
    const t = Array.isArray(this._value) ? this._value : [];
    (this._schema.list || []).forEach((i, a) => {
      const r = A(
        i,
        [...this._path, a],
        t[a],
        `${this._label ?? ""}[${a}]`
      );
      r.addEventListener("change", (c) => {
        c.stopPropagation();
        const l = Array.isArray(this._value) ? this._value.slice() : [];
        l[a] = c.detail.value, this.emitChange(l);
      }), e.appendChild(r);
    }), s.appendChild(e), this.$root.appendChild(s);
  }
}
y("schema-form-tuple", Q);
class W extends k {
  render() {
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this.makeFieldContainer("object", n.description), e = document.createElement("div");
    e.className = "group", u(e, "field-group");
    const t = this._schema.dict || {};
    Object.keys(t).forEach((i) => {
      if (t[i]?.meta?.hidden) return;
      const a = (this._value ?? {})[i], r = A(t[i], [...this._path, i], a, i);
      r.addEventListener("change", (c) => {
        c.stopPropagation();
        const l = { ...this._value ?? {} };
        l[i] = c.detail.value, this.emitChange(l);
      }), e.appendChild(r);
    }), s.appendChild(e), this.$root.appendChild(s);
  }
}
y("schema-form-object", W);
class H extends k {
  constructor() {
    super(...arguments), this._itemIds = [];
  }
  static {
    this._idCounter = 0;
  }
  generateItemId() {
    try {
      if (typeof crypto < "u" && typeof crypto.randomUUID == "function")
        return crypto.randomUUID();
    } catch {
    }
    return "i" + H._idCounter++;
  }
  ensureItemIds(n) {
    for (; this._itemIds.length < n; ) this._itemIds.push(this.generateItemId());
    this._itemIds.length > n && (this._itemIds.length = n);
  }
  // 采集当前行位置信息（用于 FLIP）
  capturePositions(n) {
    const s = {};
    return n.querySelectorAll(".row").forEach((e) => {
      const t = e.dataset.uid;
      t && (s[t] = e.getBoundingClientRect());
    }), s;
  }
  playFLIP(n, s) {
    Array.from(n.querySelectorAll(".row")).forEach((t) => {
      const i = t.dataset.uid;
      if (!i) return;
      const a = s[i];
      if (!a) return;
      const r = t.getBoundingClientRect(), c = a.left - r.left, l = a.top - r.top;
      (c || l) && (t.style.transition = "none", t.style.transform = `translate(${c}px, ${l}px)`, requestAnimationFrame(() => {
        t.style.transition = "transform .25s ease", t.style.transform = "";
      }));
    });
  }
  render() {
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this.makeFieldContainer("array", n.description), e = document.createElement("div");
    e.className = "group", u(e, "field-group");
    const t = this._schema.inner, i = () => Array.isArray(this._value) ? this._value : [];
    this.ensureItemIds(i().length);
    const a = (l, h) => {
      e.innerHTML = "", i().forEach((m, d) => {
        const p = [...this._path, d], b = document.createElement("div");
        b.className = "row schema-collection-row", u(b, "field-row", "collection-row");
        const _ = this._itemIds[d];
        b.dataset.uid = _, b.setAttribute("data-path", M(p));
        const E = A(
          t,
          p,
          m,
          `${this._label ?? ""}[${d}]`
        );
        E.addEventListener("change", ($) => {
          $.stopPropagation();
          const C = i().slice();
          C[d] = $.detail.value, this._value = C, this.emitChange(C);
        });
        const N = document.createElement("div");
        N.className = "actions", u(N, "field-actions");
        const x = document.createElement("button");
        x.type = "button", x.className = "btn", u(x, "field-button", "field-button-secondary"), x.textContent = this._i18n.arrayMoveUp ?? "↑", x.onclick = () => {
          if (d <= 0) return;
          const $ = this.capturePositions(e), C = i().slice();
          [C[d - 1], C[d]] = [C[d], C[d - 1]], [this._itemIds[d - 1], this._itemIds[d]] = [
            this._itemIds[d],
            this._itemIds[d - 1]
          ], this._value = C, a($), this.emitChange(C);
        };
        const v = document.createElement("button");
        v.type = "button", v.className = "btn", u(v, "field-button", "field-button-secondary"), v.textContent = this._i18n.arrayMoveDown ?? "↓", v.onclick = () => {
          const $ = i();
          if (d >= $.length - 1) return;
          const C = this.capturePositions(e), S = $.slice();
          [S[d + 1], S[d]] = [S[d], S[d + 1]], [this._itemIds[d + 1], this._itemIds[d]] = [
            this._itemIds[d],
            this._itemIds[d + 1]
          ], this._value = S, a(C), this.emitChange(S);
        };
        const g = document.createElement("button");
        g.type = "button", g.className = "btn danger", u(g, "field-button", "field-button-danger"), g.textContent = this._i18n.arrayRemove ?? "×", g.onclick = () => {
          b.classList.add("leaving");
          const $ = 250;
          let C = !1;
          const S = () => {
            if (C) return;
            C = !0, clearTimeout(ne);
            const U = i().filter((de, ie) => ie !== d);
            this._itemIds.splice(d, 1);
            const se = this.capturePositions(e);
            this._value = U, a(se), this.emitChange(U);
          };
          b.addEventListener("transitionend", S, { once: !0 });
          const ne = setTimeout(S, $ + 80);
        }, N.append(x, v, g), b.appendChild(E), b.appendChild(N), e.appendChild(b), h && h === _ && (b.classList.add("enter"), requestAnimationFrame(() => {
          b.classList.add("enter-active");
        }), requestAnimationFrame(() => {
          b.classList.remove("enter");
        }));
      }), l && this.playFLIP(e, l);
    };
    a();
    const r = document.createElement("button");
    r.type = "button", r.className = "btn primary", u(r, "field-button", "field-button-primary"), r.textContent = this._i18n.arrayAdd ?? "+", r.onclick = () => {
      const l = this.capturePositions(e), h = i().slice(), f = P(t);
      h.push(f);
      const m = this.generateItemId();
      this._itemIds.push(m), this._value = h, a(l, m), this.emitChange(h);
    };
    const c = document.createElement("div");
    c.className = "actions", u(c, "field-actions"), c.appendChild(r), s.appendChild(e), s.appendChild(c), this.$root.appendChild(s);
  }
}
y("schema-form-array", H);
class ee extends k {
  render() {
    this.$root.innerHTML = `<style>${L}</style>`;
    const n = w(this._schema), s = this.makeFieldContainer("dict", n.description), e = document.createElement("div");
    e.className = "group", u(e, "field-group");
    const t = this._schema.inner, i = this._value ?? {}, a = (m) => `d_${m}`, r = () => {
      const m = {};
      return e.querySelectorAll(".kv").forEach((d) => {
        const p = d.dataset.uid;
        p && (m[p] = d.getBoundingClientRect());
      }), m;
    }, c = (m) => {
      e.querySelectorAll(".kv").forEach((d) => {
        const p = d.dataset.uid;
        if (!p) return;
        const b = m[p];
        if (!b) return;
        const _ = d.getBoundingClientRect(), E = b.left - _.left, N = b.top - _.top;
        (E || N) && (d.style.transition = "none", d.style.transform = `translate(${E}px, ${N}px)`, requestAnimationFrame(() => {
          d.style.transition = "transform .25s ease", d.style.transform = "";
        }));
      });
    }, l = (m, d) => {
      e.innerHTML = "", Object.keys(i).forEach((p) => {
        const b = [...this._path, p], _ = document.createElement("div");
        _.className = "kv schema-collection-row", u(_, "field-row", "collection-row"), _.dataset.uid = a(p), _.setAttribute("data-path", M(b));
        const E = document.createElement("input");
        E.className = "input", u(E, "field-input", "field-input-text"), E.value = p, E.name = T(b) + ".__key", E.id = F(b) + "__key";
        const N = A(t, b, i[p], `${this._label ?? ""}[${p}]`), x = document.createElement("button");
        x.type = "button", x.className = "btn danger", u(x, "field-button", "field-button-danger"), x.textContent = this._i18n.dictRemove ?? "×", x.onclick = () => {
          const v = r();
          delete i[p];
          const g = { ...this._value ?? {} };
          delete g[p], this._value = g, l(v), this.emitChange(g);
        }, E.onchange = () => {
          const v = E.value.trim();
          if (!v || v === p || i[v] !== void 0) return;
          const g = r();
          i[v] = i[p], delete i[p];
          const $ = { ...this._value ?? {} };
          $[v] = $[p], delete $[p], this._value = $, l(g), this.emitChange($);
        }, N.addEventListener("change", (v) => {
          v.stopPropagation();
          const g = { ...this._value ?? {} };
          g[p] = v.detail.value, this._value = g, this.emitChange(g);
        }), _.append(E, N, x), e.appendChild(_), d === p && (_.classList.add("enter"), requestAnimationFrame(() => _.classList.add("enter-active")), requestAnimationFrame(() => _.classList.remove("enter")));
      }), m && c(m);
    };
    l();
    const h = document.createElement("button");
    h.type = "button", h.className = "btn primary", u(h, "field-button", "field-button-primary"), h.textContent = this._i18n.dictAdd ?? "+", h.onclick = () => {
      let m = Object.keys(i).length + 1, d = `k${m}`;
      for (; i[d] !== void 0; ) d = `k${++m}`;
      const p = r();
      i[d] = P(t);
      const b = { ...this._value ?? {}, [d]: i[d] };
      this._value = b, l(p, d), this.emitChange(b);
    };
    const f = document.createElement("div");
    f.className = "actions", u(f, "field-actions"), f.appendChild(h), s.appendChild(e), s.appendChild(f), this.$root.appendChild(s);
  }
}
y("schema-form-dict", ee);
class te extends HTMLElement {
  constructor() {
    super(), this._i18n = { ...K }, this._i18nCommitted = !1, this.$root = this.attachShadow({ mode: "open" });
    const n = document.createElement("style");
    n.textContent = L, this.$root.appendChild(n);
    const s = document.createElement("div");
    s.className = "wrapper", u(s, "wrapper");
    const e = document.createElement("form");
    e.className = "form", u(e, "form"), s.appendChild(e), this.$root.appendChild(s), this.addEventListener("change", (t) => {
      if (!t?.detail) return;
      const { path: i, value: a } = t.detail;
      Array.isArray(i) && i.length === 0 ? this._state = a : ae(this._state ?? (this._state = {}), i, a), this.dispatchEvent(
        new CustomEvent("form-change", { detail: { path: i, value: a, state: this._state } })
      );
    });
  }
  // --- 对外 API ---
  set schema(n) {
    this._schema = V(n);
    try {
      this._state = this._schema(null, { autofix: !0 });
    } catch {
      this._state = P(this._schema);
    }
    this.render();
  }
  get schema() {
    return this._schema;
  }
  set schemaJSON(n) {
    this.schema = n;
  }
  get schemaJSON() {
    return this._schema?.toJSON?.();
  }
  setData(n, s = { validate: !0, autofix: !0 }) {
    if (!this._schema) throw new Error("请先设置 schema");
    const e = s.validate ? this._schema(n ?? null, { autofix: s.autofix }) : n;
    this._state = e, this.render();
  }
  getData(n = { validate: !0, autofix: !0 }) {
    if (!this._schema) throw new Error("请先设置 schema");
    const s = this._state;
    return n.validate ? this._schema(s ?? null, { autofix: n.autofix }) : s;
  }
  reset() {
    try {
      this._state = this._schema(null, { autofix: !0 });
    } catch {
      this._state = P(this._schema);
    }
    this.render();
  }
  refresh() {
    this.render();
  }
  // i18n 相关
  set i18n(n) {
    this._i18nCommitted || (this._i18n = { ...this._i18n, ...n }, this._i18nCommitted = !0, this.render());
  }
  get i18n() {
    return this._i18n;
  }
  render() {
    if (!this._schema) return;
    const n = this.$root.querySelector("form");
    n.innerHTML = "";
    const s = A(
      this._schema,
      [],
      this._state,
      this._i18n.rootLabel,
      this._i18n
    );
    n.appendChild(s);
  }
}
y("schema-form", te);
function he(o, n) {
  const s = document.createElement("schema-form");
  s.schema = o, n?.i18n && (s.i18n = n.i18n), n?.value && s.setData(n.value);
  const e = n?.onChange, t = () => {
    try {
      e?.(s.getData());
    } catch {
    }
  };
  return e && s.addEventListener("form-change", t), {
    el: s,
    mount: (i) => {
      if (typeof i == "string") {
        const a = document.querySelector(i);
        if (!a) throw new Error("未找到挂载节点：" + i);
        a.innerHTML = "", a.appendChild(s);
      }
      if (i instanceof HTMLElement)
        i.innerHTML = "", i.appendChild(s);
      else
        throw new Error("挂载节点必须是 HTMLElement 或 选择器字符串");
      return s;
    },
    setData: (i, a) => s.setData(i, a),
    getData: (i) => s.getData(i),
    destroy: () => {
      e && s.removeEventListener("form-change", t), s.remove();
    }
  };
}
function ue() {
  y("schema-form", te), y("schema-form-string", I), y("schema-form-number", J), y("schema-form-boolean", Y), y("schema-form-date", X), y("schema-form-const", B), y("schema-form-union", G), y("schema-form-tuple", Q), y("schema-form-object", W), y("schema-form-array", H), y("schema-form-dict", ee), y("schema-form-intersect", Z);
}
export {
  K as DEFAULT_I18N,
  te as SchemaForm,
  he as createSchemasteryForm,
  ue as install
};
//# sourceMappingURL=index.js.map
